import { render, staticRenderFns } from "./Kernel.vue?vue&type=template&id=2b1289cc&scoped=true&"
import script from "./Kernel.vue?vue&type=script&lang=js&"
export * from "./Kernel.vue?vue&type=script&lang=js&"
import style0 from "./Kernel.vue?vue&type=style&index=0&id=2b1289cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1289cc",
  null
  
)

export default component.exports